import router from "../../../router";
import axios from "axios";

export default {
    loadEmployeeList({ commit, dispatch }, payload)
    {
        return new Promise((resolve, reject) => {
            let filter_fields = this.getters['employees/getEmployeeFilterFields'];
            let main_filter = this.getters['employees/getEmployeeMainFilter'];

            dispatch('pagePreloader/setPagePreloaderIsActive', true, {root: true});

            commit('setEmployeeList', []);

            if (!main_filter && router.currentRoute.query.main_filter) {
                main_filter = router.currentRoute.query.main_filter;

                commit('setEmployeeFilterFieldsMutation', {main_filter: router.currentRoute.query.main_filter});
            }

            if (!filter_fields.employeeId && router.currentRoute.query.employee_id) {
                filter_fields.employeeId = router.currentRoute.query.employee_id;

                commit('setEmployeeFilterFieldsMutation', {field_name: 'employeeId', field_value: router.currentRoute.query.employee_id})
            }

            payload['filter_fields'] = filter_fields;
            payload['main_filter'] = main_filter;

            axios.post('/api/employee/list', payload).then((response) => {
                const result = response.data.data;

                if (response.data.data.code != 'ok')
                {
                    resolve({
                        error: true,
                        error_msg: 'Server response code not ok!',
                    });

                    return;
                }

                if (!response.data.data.result) {
                    resolve({
                        error: true,
                        error_msg: 'Result is empty!',
                    });

                    return;
                }

                dispatch('pagePreloader/setPagePreloaderIsActive', false, {root: true});

                commit('setEmployeeList', response.data.data.result.clients);
                commit('setEmployeeListCount', response.data.data.result.clients_count);

                resolve(true);
            }).catch((error) => {
                reject(false);
            });
        });
    },
    setEmployeeFilterFields({ commit }, payload)
    {
        commit('setEmployeeFilterFieldsMutation', payload);
    },
    deleteEmployees({ commit }, payload)
    {
        return new Promise((resolve, reject) => {
            axios.post('/api/client/delete-clients', {
                ids: payload
            }).then(response => {
                const result = response.data.data;

                if (response.data.data.result.success !== true) {
                    resolve(false);
                }

                commit('deleteEmployeesMutation', payload);

                resolve(true);
            }).catch(error => {
                reject(error);
            });
        });
    },
    setEmployeeModalOpen({commit}, payload)
    {
        commit('setEmployeeModalOpenMutation', payload);
    },
    setEmployeeIdAndEmployeeIndexToModalForm({commit}, payload)
    {
        commit('setEmployeeIdAndEmployeeIndexToModalFormMutation', payload);
    },
    addEmployeeToEmployeeList({commit}, payload)
    {
        commit('addEmployeeToEmployeeList', payload);
    },
    updateEmployee({ commit }, payload)
    {
        commit('updateEmployee', payload);
    },
}
